import { render, staticRenderFns } from "./forwarding.vue?vue&type=template&id=0aa4c06b&scoped=true&"
import script from "./forwarding.vue?vue&type=script&lang=js&"
export * from "./forwarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa4c06b",
  null
  
)

export default component.exports